import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './en.json';
import es from './es.json';

Vue.use(VueI18n);

export function detectLocale () {
  let locale = (navigator.language || navigator.browserLanguage).toLowerCase();
  switch (true) {
    case /^en.*/i.test(locale):
      locale = 'en';
      break;
    case /^es.*/i.test(locale):
      locale = 'es';
      break;
    default:
      locale = 'en';
  }

  return locale;
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: {
    'en': en,
    'es': es,
  }
});

export default i18n;
